export default __webpack_public_path__ + "static/avatarGirl3-6b3aa7a69b7e0c15ed7307d571e74df3.png";